export default class spTurnDevice{
    constructor(ua){

        this.ua = ua;

        /* 必要なDOM */

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
        }

    }
    resize(){

        var angle = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0;

        let _roule = (this.ua==="sp")?angle % 180 !== 0:window.innerHeight < window.innerWidth;

        if(_roule) {
            $("body").addClass("is-landscape");
        } else {
            $("body").removeClass("is-landscape");
        }

    }
}